import {
    Button
} from "@chakra-ui/react";
import "./style.scss";

export const TesteFlag = ({
    isLogged = false
}) => {

    if (process.env.REACT_APP_TESTE === 'false') return (null);

    const ambiente = sessionStorage.getItem('@FPontos:ambiente') || 'hml';

    const openInNewTab = (url: string) => {
        window.location.replace(url);
    };

    return (
        <div className={ambiente === 'prod' ? 'ambiente-teste-prod' : "ambiente-teste"} style={{margin : isLogged ? '0' : '-6px'}}>
            <span>Ambiente de Teste ({ambiente})</span>
            <Button
                onClick={() => openInNewTab('https://farmapontos.com.br/')}
                color="#FFFF"
                className="ambiente-teste-button"
                fontSize={12}
                height="30px"
                >
                Acessar site
            </Button>
        </div>
    )
};
